export class Leg {
    depart: string;
    arrive: string;
    time: Date;
    timeLocal: Date;
}